import { FunctionalComponent, h, Build } from '@stencil/core';
import get from 'lodash/get'
import { AppMedia, AppLink } from './'
import { AppNavProducts, AppNavAbout, AppNavOwners } from '.'

interface SectionHeader {
    data?: any;
}

declare var UIkit;

export const SectionHeader: FunctionalComponent<SectionHeader> = ({ data }) => {

    const { About, Contact, Logo, Owners, Products, ContactButtons, TopLinks = [] } = data;
    const route = window.location.pathname;

    const getActive = (route, routes) => {
        if (!Build.isBrowser) return false;
        return routes.includes(route) ? 'uk-active' : ''
    }

    const getLinks = (nav) => {
        const links = (get(nav, 'List1') || []).concat(get(nav, 'List2'), get(nav, 'List3'), get(nav, 'List4'))
            .map((link) => {
                return get(link, 'page.data.attributes.Slug') ? '/' + get(link, 'page.data.attributes.Slug') : get(link, 'URL')
            });
        return links
    }

    return (
        <div class="uk-visible@s">
            <div class="uk-background-primary-striped uk-position-relative wsio-angle-header">
                <div class="uk-container uk-container-xlarge uk-light uk-padding-small">
                    <div class="uk-child-width-1-1 uk-child-width-1-2@m" uk-grid>
                        <div>
                        </div>
                        <div>
                            <div class="uk-position-relative uk-flex uk-flex-right uk-flex-middle">
                                {
                                    TopLinks.map((link, i) => [
                                        <span hidden={i == 0} class="uk-margin-small-right uk-margin-small-left">/</span>,
                                        <AppLink className="uk-button uk-button-link uk-text-small" data={link} />
                                    ]
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <header class="uk-position-z-index uk-background-glass wsio-header" uk-sticky="show-on-up: true; animation: uk-animation-slide-top; sel-target: .uk-navbar-container; cls-active: uk-navbar-sticky">
                <div class="uk-position-relative uk-padding">
                    <div class="uk-container uk-container-xlarge">
                        <nav id="hero-nav-dropbar" class="uk-navbar-container uk-navbar-transparent" uk-navbar="dropbar:true; mode:click; stretch:x;">
                            <div class="uk-navbar-left">
                                <ul class="uk-navbar-nav">
                                    <li class="uk-flex uk-flex-middle uk-position-relative">
                                        <a class="logo-responsive" aria-label='Logo' href="/">
                                            <AppMedia media={Logo} className='uk-width-logo uk-position-z-index' eager />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="uk-navbar-center@l uk-navbar-right">
                                <ul class="uk-navbar-nav">
                                    <li class={`${getActive(route, ['/'])} uk-visible@m`}>
                                        <AppLink className="uk-heading-small" data={{ URL: '/', Label: 'Home' }} />
                                    </li>
                                    <li class={`${getActive(route, getLinks(Products))}`}>
                                        <a class="uk-heading-small" href="#" rel="nofollow" >{get(Products, 'Label')}</a>
                                        <AppNavProducts data={Products} />
                                    </li>
                                    <li class={`${getActive(route, getLinks(Owners))}`}>
                                        <a class="uk-heading-small" href="#" rel="nofollow" >{get(Owners, 'Label')}</a>
                                        <AppNavOwners data={Owners} />
                                    </li>
                                    <li class={`${getActive(route, getLinks(About))}`}>
                                        <a class="uk-heading-small" href="#" rel="nofollow" >{get(About, 'Label')}</a>
                                        <AppNavAbout data={About} />
                                    </li>
                                    <li class={`${getActive(route, ['/contact'])}`}>
                                        <AppLink className="uk-heading-small" data={{ URL: '/contact', Label: get(Contact, 'Label') }} />
                                    </li>
                                </ul>
                            </div>
                            <div class="uk-navbar-right uk-visible@l">
                                <ul class="uk-navbar-nav">
                                    {
                                        ContactButtons.slice(0, 3).map((btn) => <li class="uk-flex uk-flex-middle" uk-tooltip={btn.Label}><AppLink className="color-primary uk-margin-left uk-icon-button" data={{ ...btn, HideLabel: true }} /></li>)
                                    }
                                </ul>
                            </div>
                        </nav>
                        <div class="uk-navbar-dropbar wsio-dropbar uk-position-z-index">
                        </div>
                    </div>
                </div>
            </header>
        </div>
    )
};


